import React from 'react';
import MemberCode from './MemberCode';

function App() {
  return (
    <div className="App">
      <MemberCode />
    </div>
  );
}

export default App; 